<template>
<div class="row">
    <div class="row">
        <div class="form-group search-wrapper" style="margin:0 auto;">
            <input type="email" class="form-control mb-3 border border-secondary" v-model="search" placeholder="Kërko sipas titullit" autofocus>
        </div>


        
    </div>
    <div class="row">

     <div class="text-center" v-if="loader">
        <div class="spinner-border" role="status">
            <span class="visually-hidden"></span>
        </div>
    </div>
   
    <v-card v-for="i in filteredList" class="mx-auto mt-3" width="300">
        <v-img :src="i.img" height="200px" width="100%" contain></v-img>

        <v-card-title> {{i.title}} </v-card-title>
        <v-card-subtitle> {{i.author}} </v-card-subtitle>

        <v-card-actions>
            <v-btn color="orange-lighten-2" variant="text" :href=i.link target="_blank">
                Shkarko
            </v-btn>

            <v-spacer></v-spacer>

            
        </v-card-actions>

    </v-card>
    </div>

</div>
</template>

<script>
import { APISettings } from '../api/config.js'


class Post {
    constructor(title, link, author, img) {
        this.title = title;
        this.link = link;
        this.author = author;
        this.img = img;
    }
}

export default {
    data() {
        return {
            loader: false,
            search: '',
            postList: [],
        }

    },
    methods: {
        getData() {
            this.loader = true;
            var get_token = this.$cookies.get("accesstoken");
            fetch(APISettings.baseURL + `Librari/getLibrat/1`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + get_token
                    },
                })
                .then(
                    (signinResponse) => {
                        signinResponse.json().then((res) => {
                            if (signinResponse.status === 200) {
                                res.forEach((obj, i) => {

                                    var post = new Post(`${obj.titulli}`, `${obj.url}`, `${obj.autori}`, `${obj.imgpath}`);
                                    this.postList.push(post);

                                });
                            } else if (signinResponse.status === 400) {
                                console.log("ERROR DATA1");
                            }
                            this.loader = false;
                        })
                    }).catch(error => {
                    console.log("ERROR DATA2");
                })

        },
    },
    computed: {
        filteredList() {
            return this.postList.filter(post => {
                return (post.title.toLowerCase().includes(this.search.toLowerCase()));
            })
        }
    },
    beforeMount() {
        this.getData();

    },

}
</script>

<style scoped>
input::-webkit-input-placeholder {
    color:grey;
    font-weight: 600;
    background:white;
}
input{
    box-shadow: 0 2px 2px rgb(220 59 69 / 50%);
}
</style>
